import { debounce, isNil, isEmpty, filter } from 'lodash';
// @ts-expect-error $TSFixMeError: Could not find a declaration file for module 'd3-selection'. '/home/pedro/projects/mews-js/node_modules/d3-selection/bui...
import { event } from 'd3-selection';
import 'd3-transition';
// @ts-expect-error $TSFixMeError: Could not find a declaration file for module 'd3-xyzoom'. '/home/pedro/projects/mews-js/node_modules/d3-xyzoom/build/d3-...
import { xyzoom } from 'd3-xyzoom';
// @ts-expect-error $TSFixMeError: Could not find a declaration file for module 'd3-drag'. '/home/pedro/projects/mews-js/node_modules/d3-drag/build/d3-drag...
import { drag } from 'd3-drag';
import { timer as d3Timer } from 'd3-timer';
import { KeyValue } from '@mews/enums';
import { ANIMATION_DURATION } from '@optimus-web/common';
import {
    MIN_ZOOM,
    KEYBOARD_MOVE_SPEED,
    AUTO_DRAG_SPEED,
    LINE_HEIGHT,
    MAX_ZOOM,
    LONG_PRESS_THRESHOLD,
    DENSITY_ZOOM_VALUE,
    DATE_LEGEND_HEIGHT,
} from '../constants';
import { distance, axisDistanceInvert } from '../utils/mathUtils';
import { isOtherService } from '../utils/services';
import { getArrowsNavigationDistance } from '../utils/timeUnit';
import { CursorPosition } from '../types';
import Model from './model';

const PINCH_SCALE = 2;

export default function Controls(
    element: $TSFixMe,
    state: $TSFixMe,
    tooltip: $TSFixMe,
    quickScroll: $TSFixMe,
    model: ReturnType<typeof Model>,
    requestDraw: $TSFixMe,
    mouseClick: $TSFixMe,
    mouseMove: $TSFixMe,
    onViewPortChanged: $TSFixMe,
    moveEnded: $TSFixMe,
    resourceUseDragged: $TSFixMe,
    selectResourceUse: $TSFixMe,
    deselectResourceUse: $TSFixMe,
    canManageReservations: $TSFixMe,
    timelineTouchScreenTest: boolean,
    isPercentageDensityValuesEnabled: boolean,
    isTimelineTouchMoveEnabled: boolean
) {
    let zooming = false;
    let dragging = false;
    let quickScrolling = false;
    let moving = false;
    let mouseWheelPressed = false;
    let spacebarPressed = false;
    let speedTimer: $TSFixMe = null;
    let speed = { x: 0, y: 0 };
    let lastTimeCheck = 0;
    let lastZoomTransform = {
        x: 0,
        y: 0,
        kx: 1,
        ky: 1,
    };
    const keyState: Record<string, boolean> = {};
    let resourceUseDragStartYDisplacement = 0;
    let longPressTimeoutId: $TSFixMe = null;
    let pinchDistance = 0;
    let startScale: number = state.scale;

    let zoom: $TSFixMe = null;

    const handleMoveEnd = debounce(moveEnded, 700);

    element
        .on('touchstart', () => {
            window.clearTimeout(longPressTimeoutId);
            if (event.touches.length === 1) {
                const e = event.touches[0];
                longPressTimeoutId = window.setTimeout(() => {
                    longPressTimeoutId = null;
                    const mousePosition = getMousePosition(e);
                    if (selectResourceUse(mousePosition) && dragResourceUseStart(mousePosition)) {
                        resourceUseDragStartYDisplacement = state.yAxis.invert(mousePosition.y);
                    }
                }, LONG_PRESS_THRESHOLD);
            }

            if (event.touches.length === 2) {
                startScale = state.scale;
                pinchDistance = getPinchDistance(event);
            }
        })
        .on('touchmove', () => {
            window.clearTimeout(longPressTimeoutId);
            if (event.touches.length === 2) {
                const d = getPinchDistance(event);
                element
                    .transition()
                    .duration(0)
                    .call(zoom.scaleTo, 1, startScale + (1 - pinchDistance / d) / PINCH_SCALE);
            }
        })
        .on('touchend', () => {
            window.clearTimeout(longPressTimeoutId);
            if (event.touches.length === 0 && event.changedTouches.length === 1) {
                if (dragging && state.selectedResourceUse) {
                    dragResourceUseEnd(getMousePosition(event.changedTouches[0]));
                    resourceUseDragStartYDisplacement = 0;
                }
            }
            dragging = false;
        })
        .on('click', () => {
            mouseClick(getMousePosition(event));
        })
        .on('mousemove', () => {
            if (zooming || dragging) {
                tooltip.hide();
                return;
            }
            if (mouseWheelPressed) {
                moveBy(event.movementX, event.movementY);
            }
            mouseMove(getMousePosition(event));
        })
        .on('mousedown', () => {
            if (spacebarPressed) {
                moveBy(event.movementX, event.movementY);
            }

            if (event.button === 1) {
                mouseWheelPressed = true;
            }
        })
        .on('mouseup', () => {
            mouseWheelPressed = false;
        })
        .on('mouseleave', () => {
            tooltip.hide();
        })
        .on('wheel', () => {
            if (event.ctrlKey || event.metaKey) {
                // When Ctrl or Cmd is pressed, prevent whole page zooming with mouse wheel
                if (keyState[KeyValue.Control] || keyState[KeyValue.Meta]) {
                    event.preventDefault();
                }
                return;
            }
            if (isTimelineTouchMoveEnabled) {
                element.on('.zoom', null);
            }
            // To prevent browser back/forward with two finger swipe
            if (!timelineTouchScreenTest) {
                event.preventDefault();
            }

            if (event.shiftKey) {
                // There is a difference between external mouse on mac a on windows. Mac has values on deltaX, windows on deltaY.
                moveBy(-event.deltaY || -event.deltaX, 0);
            } else {
                moveBy(-event.deltaX, -event.deltaY);
            }
        });

    element.call(
        drag()
            .on('drag', () => {
                if (event.dx === 0 && event.dy === 0) {
                    return;
                }

                moving = true;

                if (dragging) {
                    dragResourceUse(event);
                } else if (quickScrolling) {
                    quickScrollCanvas(event);
                } else {
                    dragCanvas(event);
                }
            })
            .on('start', () => {
                const mousePosition = getMousePosition(event.sourceEvent);
                if (quickScroll.isVisible() && quickScroll.collides(mousePosition)) {
                    quickScrolling = true;
                    return;
                }
                if (canManageReservations && state.selectedResourceUse) {
                    if (dragResourceUseStart(mousePosition)) {
                        resourceUseDragStartYDisplacement = state.yAxis.invert(mousePosition.y);
                    }
                }
            })
            .on('end', () => {
                if (dragging && state.selectedResourceUse) {
                    dragResourceUseEnd(getMousePosition(event.sourceEvent));
                    resourceUseDragStartYDisplacement = 0;
                }

                handleMoveEnd();
                speed = { x: 0, y: 0 };
                dragging = false;
                quickScrolling = false;
                moving = false;
            })
    );

    zoom = xyzoom()
        .extent([
            [state.xAxis.range()[0], state.yAxis.range()[0]],
            [state.xAxis.range()[1], state.yAxis.range()[1]],
        ])
        .scaleRatio([0, 1])
        .scaleExtent([
            [1, 1],
            [MAX_ZOOM, MIN_ZOOM],
        ])
        .on('zoom', () => {
            const dy = lastZoomTransform.y - event.transform.y;

            state.scale = event.transform.ky;
            state.xAxis = event.transform.rescaleX(state.constXAxis);
            state.yAxis = event.transform.rescaleY(state.constYAxis);

            if (!quickScrolling) {
                quickScroll.move({
                    dy: (dy / getTimelineHeight()) * state.canvasHeight * state.scale,
                    canvasHeight: state.canvasHeight,
                });
            }
            quickScroll.resize(state.canvasHeight, getTimelineHeight(), event.transform.ky);

            lastZoomTransform = event.transform;

            const maxYTranslate = Math.max(
                model.getResourcesMaxY() * LINE_HEIGHT + DATE_LEGEND_HEIGHT / state.scale,
                state.canvasHeight
            );
            zoom.translateExtent([
                [Number.NEGATIVE_INFINITY, 0],
                [Number.POSITIVE_INFINITY, maxYTranslate],
            ]);

            onViewPortChanged();
            requestDraw();
        })
        .on('start', () => {
            zooming = true;
        })
        .on('end', () => {
            if (!isMoving()) {
                handleMoveEnd();
            }
            zooming = false;
        });

    if (isTimelineTouchMoveEnabled) {
        element.call(zoom);
    }

    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('keyup', onKeyUp);

    return {
        dispose() {
            window.removeEventListener('keydown', onKeyDown);
            window.removeEventListener('keyup', onKeyUp);
            handleMoveEnd.cancel();
            element.remove();
            window.clearTimeout(longPressTimeoutId);
        },
        goToUse(use: $TSFixMe) {
            const x = state.xAxis(use.minX) - 250;
            const y = state.yAxis(use.minY) - 100;
            moveBy(-x, -y);
        },
        goToResource(resource: $TSFixMe) {
            return moveBy(0, -state.yAxis(resource.minY));
        },
        goToIndex(index: $TSFixMe, isAnimationDisabled: $TSFixMe) {
            const x = -state.xAxis((state.initialOffset as number) + (index as number));
            const y = 0;
            return isAnimationDisabled ? moveBy(x, y) : animateMoveBy(x, y);
        },
        prevFast(timeUnit: $TSFixMe) {
            animateMoveBy(getArrowsNavigationDistance({ timeUnit, fast: true }), 0);
        },
        prev(timeUnit: $TSFixMe) {
            animateMoveBy(getArrowsNavigationDistance({ timeUnit }), 0);
        },
        today() {
            // @ts-expect-error $TSFixMeError: Expected 2 arguments, but got 1.
            this.goToIndex(0);
        },
        next(timeUnit: $TSFixMe) {
            animateMoveBy(-getArrowsNavigationDistance({ timeUnit }), 0);
        },
        nextFast(timeUnit: $TSFixMe) {
            animateMoveBy(-getArrowsNavigationDistance({ timeUnit, fast: true }), 0);
        },
        updateZoom(height: number, minHeight: $TSFixMe) {
            const zoomToAllResources = minHeight / (height + LINE_HEIGHT);
            zoom.scaleExtent([
                [1, 1],
                [zoomToAllResources < MIN_ZOOM ? zoomToAllResources : MIN_ZOOM, MIN_ZOOM],
            ]);
        },
        changeDensity(density: number | string) {
            if (isPercentageDensityValuesEnabled) {
                element.transition().duration(0).call(zoom.scaleTo, density, density);
            } else {
                const densityValue = DENSITY_ZOOM_VALUE[density];
                element.transition().duration(0).call(zoom.scaleTo, densityValue, densityValue);
            }
        },
        forceRedraw() {
            moveBy(0, 0);
        },
        getTimelineHeight,
        handleResize(width: $TSFixMe, height: $TSFixMe) {
            zoom.extent([
                [0, 0],
                [width, height],
            ]);
            moveBy(0, 0);
        },
        updateState({ isTimelineDraggingEnabled }: $TSFixMe) {
            state.isTimelineDraggingEnabled = isTimelineDraggingEnabled;
        },
    };

    function dragResourceUseStart(position: CursorPosition) {
        const resourceUse = model.getResourceUseAtPosition(position);
        const { selectedResourceUse } = state;
        const isOtherServiceUse =
            selectedResourceUse?.serviceId && isOtherService(selectedResourceUse.serviceId, state.serviceId);

        if (
            resourceUse &&
            resourceUse.isMoveable &&
            resourceUse.id === selectedResourceUse.id &&
            !isOtherServiceUse &&
            state.isTimelineDraggingEnabled
        ) {
            dragging = true;
            selectedResourceUse.displaceY = 0;
            return true;
        }
        return false;
    }

    function dragResourceUse(e: $TSFixMe) {
        if (isNil(state.selectedResourceUse)) {
            return;
        }

        const { canvasHeight } = state;
        let { sourceEvent } = e;
        if (sourceEvent.touches && sourceEvent.touches.length === 1) {
            sourceEvent = e.sourceEvent.touches[0];
        }
        const position = getMousePosition(sourceEvent);

        state.selectedResourceUse.displaceY = state.yAxis.invert(position.y) - resourceUseDragStartYDisplacement;
        state.highlightedSpaces = model.getHighlightedResources(position);

        speed = { x: 0, y: 0 };

        // vertical autoscroll
        const autoScrollSize = canvasHeight / 6;
        if (position.y < autoScrollSize && state.viewport.minY !== 0) {
            speed.y = ((autoScrollSize - position.y) / autoScrollSize) * AUTO_DRAG_SPEED;
        }

        if (canvasHeight - position.y < autoScrollSize && state.yAxis.invert(canvasHeight) < model.getResourcesMaxY()) {
            speed.y = (-(position.y - (canvasHeight - autoScrollSize)) / autoScrollSize) * AUTO_DRAG_SPEED;
        }

        checkSpeedTimer();
        requestDraw();
    }

    function dragResourceUseEnd(position: CursorPosition) {
        state.highlightedSpaces = [];
        const forceAssign = !isEmpty(
            filter(model.getResourceUsesAtPosition(position), (use) => use.id !== state.selectedResourceUse.id)
        );
        resourceUseDragged(state.selectedResourceUse, model.getResourceAtY(position), forceAssign);
    }

    function getTimelineHeight() {
        return zoom.translateExtent()[1][1];
    }

    function onKeyDown(e: $TSFixMe) {
        if (e.repeat) return;

        if (e.keyCode === 32) {
            spacebarPressed = true;
        }
        if (e.key === KeyValue.Control || e.key === KeyValue.Meta) {
            element.call(zoom);
        }
        updateKeyState(e, true);
    }

    function onKeyUp(e: $TSFixMe) {
        spacebarPressed = false;
        if (e.key === KeyValue.Control || e.key === KeyValue.Meta) {
            element.on('.zoom', null);
        }
        updateKeyState(e, false);
    }

    function keyChange() {
        speed = {
            x: axisSpeed(KeyValue.ArrowLeft, KeyValue.ArrowRight),
            y: axisSpeed(KeyValue.ArrowUp, KeyValue.ArrowDown),
        };

        checkSpeedTimer();
        tooltip.hide();
    }

    function keySpeed(key: KeyValue) {
        return (keyState[key] ? 1 : 0) * KEYBOARD_MOVE_SPEED;
    }

    function axisSpeed(key1: KeyValue, key2: KeyValue) {
        return keySpeed(key1) - keySpeed(key2);
    }

    function updateKeyState(e: $TSFixMe, isDown: $TSFixMe) {
        if (e.target !== document.body) {
            return;
        }
        if (e.key === KeyValue.Escape && !isDown) {
            deselectResourceUse();
            return;
        }

        keyState[e.key] = isDown;
        // @ts-expect-error $TSFixMeError: Expected 0 arguments, but got 1.
        keyChange(e);
    }

    function isMoving() {
        return moving || speed.x !== 0 || speed.y !== 0;
    }

    function checkSpeedTimer() {
        if (!speedTimer && isMoving()) {
            // @ts-expect-error $TSFixMeError: Type 'null' is not assignable to type 'number'.
            lastTimeCheck = null;
            speedTimer = true;
            const timer = d3Timer((t) => {
                if (!isMoving()) {
                    timer.stop();
                    speedTimer = false;
                    return true;
                }
                const change = (t - (lastTimeCheck || t - 14)) / 1000;

                lastTimeCheck = t;

                const moveX = speed.x * change;
                const moveY = speed.y * change;

                moveBy(moveX, moveY);

                const maxYTranslate = getTimelineHeight();
                if (
                    dragging &&
                    state.selectedResourceUse &&
                    (state.selectedResourceUse.displaceY as number) + (state.selectedResourceUse.minY as number) > 0 &&
                    (state.selectedResourceUse.displaceY as number) + (state.selectedResourceUse.maxY as number) <
                        axisDistanceInvert(state.yAxis, maxYTranslate)
                ) {
                    state.selectedResourceUse.displaceY += axisDistanceInvert(state.yAxis, -moveY) * state.scale;
                }
                return false;
            });
        }
    }

    function dragCanvas(e: $TSFixMe) {
        moveBy(e.dx, e.dy / state.scale);
    }

    function quickScrollCanvas(e: $TSFixMe) {
        const change = -e.dy / state.canvasHeight;
        quickScroll.move({ dy: e.dy, canvasHeight: state.canvasHeight });
        moveBy(0, getTimelineHeight() * change);
        requestDraw();
    }

    function animateMoveBy(x: $TSFixMe, y: $TSFixMe) {
        const d = distance(x, y);
        moveBy(x, y, Math.sqrt(d / ANIMATION_DURATION.fast) * ANIMATION_DURATION.fast);
    }

    function moveBy(x: $TSFixMe, y: $TSFixMe, duration = 0) {
        element.transition().duration(duration).call(zoom.translateBy, x, y);
    }

    function getMousePosition(e: $TSFixMe) {
        const offset = element.node().getBoundingClientRect();
        return {
            x: e.pageX - offset.left,
            y: e.pageY - offset.top,
        };
    }

    function getPinchDistance(e: $TSFixMe) {
        const x = e.touches[0].pageX - e.touches[1].pageX;
        const y = e.touches[0].pageY - e.touches[1].pageY;
        return distance(x, y);
    }
}
